import { FONT } from "@/styles/common";
import { Table, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 52, 500)}
    text-align: center;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 32, 500)}
    }
`;

export const CustomTable = styled(Table)`
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
    border-top: 1px solid ${({ theme }) => theme.COLOR.text[400]};

    & tr {
        height: 48px;
        box-sizing: border-box;
    }

    & th,
    td {
        white-space: nowrap;
        padding: 0 8px;
        ${FONT("pretendard", 16, 300)}
        text-align: center;
        border-bottom: 1px solid ${({ theme }) => theme.COLOR.text[400]} !important;
    }

    & th {
        color: ${({ theme }) => theme.COLOR.text[400]};
        background: ${({ theme }) => theme.COLOR.pagination[100]};
    }
`;
